import React from "react";
import DataList from "components/datatable/DataList";
import useAxios from "hooks/useAxios";
import useAxiosFunction from "hooks/useAxiosFunction";
import useMsgBox from "hooks/useMsgBox";
import { listItems, showEmpty } from "features/kms/system/SystemPageUtils";

export function KejuaraanAdminTargetMedaliPage() {
  const [showMsg] = useMsgBox();
  const [, , loading, axiosFetch] = useAxiosFunction();
  const [reload, setReload] = React.useState(0);
  const [medaliResp] = useAxios({ method: "GET", url: "/references/medali", auth: true });
  const [caborResp] = useAxios({ method: "GET", url: "/references/kejuaraan-admin-medali-cabor", auth: true });
  const [kategoriResp] = useAxios({ method: "GET", url: "/references/nomor-kategori", auth: true });
  const [penentuResp] = useAxios({ method: "GET", url: "/references/nomor-penentu-keberhasilan", auth: true });
  const caborOptions = listItems(caborResp);
  const kategoriOptions = listItems(kategoriResp);
  const penentuOptions = listItems(penentuResp);
  const medaliOptions = React.useMemo(
    () => [{ id_jenis_medali: 0, nama: "Tak Ada" }, ...listItems(medaliResp)],
    [medaliResp]
  );
  const hasilOptions = [
    { value: "", label: "-" },
    { value: "EMAS", label: "Emas" },
    { value: "PERAK", label: "Perak" },
    { value: "PERUNGGU", label: "Perunggu" },
    { value: "KALAH", label: "Kalah" },
  ];
  const isTargetLocked = (item) => item?.is_target_locked === true || item?.is_target_locked === "true";
  const isHasilLocked = (item) => item?.is_final === true || item?.is_final === "true";

  const saveMonitoring = async (item, changes = {}) => {
    const result = await axiosFetch({
      method: "PUT",
      url: `/kejuaraan-admin/evaluasi/monitoring-medali/${item.id_nomor_pertandingan}`,
      auth: true,
      data: {
        id_jenis_medali: Number(changes.id_jenis_medali ?? item?.id_jenis_medali_target ?? 0),
        hasil: changes.hasil ?? item?.hasil_value ?? "",
      },
    });
    if (result?.success === true || result?.data?.success === true) {
      showMsg("Informasi", "Monitoring Medali berhasil disimpan");
      setReload((current) => current + 1);
      return;
    }
    showMsg("Error", result?.data?.message || result?.message || "Monitoring Medali gagal disimpan");
  };

  const coltype = {
    cabor_name: { label: "Cabor", renderFunc: (val) => showEmpty(val), width: 170 },
    nomor_pertandingan_name: { label: "Nomor Pertandingan", renderFunc: (val) => showEmpty(val), width: 220 },
    nomor_kategori_name: { label: "Kategori", renderFunc: (val) => showEmpty(val), width: 150 },
    penentu_keberhasilan_name: { label: "Penentu Keberhasilan", renderFunc: (val) => showEmpty(val), width: 260 },
    target_name: {
      label: "Target",
      align: "center",
      width: 130,
      renderFunc: (val, col, item) => (
        <select
          className="form-control form-control-sm"
          value={item?.id_jenis_medali_target ?? 0}
          disabled={loading || isTargetLocked(item)}
          title={isTargetLocked(item) ? "Target terkunci karena sudah diisi pada detail atlet" : "Ubah Target"}
          onChange={(event) => saveMonitoring(item, { id_jenis_medali: event.target.value })}
        >
          {medaliOptions.map((option) => (
            <option key={option.id_jenis_medali} value={option.id_jenis_medali}>
              {option.nama}
            </option>
          ))}
        </select>
      ),
      renderExportFunc: (val) => showEmpty(val, "Tak Ada"),
    },
    hasil_name: {
      label: "Hasil",
      align: "center",
      width: 110,
      renderFunc: (val, col, item) => (
        <select
          className="form-control form-control-sm"
          value={item?.hasil_value || ""}
          disabled={loading || isHasilLocked(item)}
          title={isHasilLocked(item) ? "Hasil terkunci karena sudah memiliki evidence pencatatan medali" : "Ubah Hasil"}
          onChange={(event) => saveMonitoring(item, { hasil: event.target.value })}
        >
          {hasilOptions.map((option) => (
            <option key={option.value || "kosong"} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      ),
      renderExportFunc: (val) => showEmpty(val, "-"),
    },
  };
  const columns = ["no", "cabor_name", "nomor_pertandingan_name", "nomor_kategori_name", "penentu_keberhasilan_name", "target_name", "hasil_name"];

  return (
    <DataList
      title="Monitoring Medali"
      reload={reload}
      coltype={coltype}
      dlist={{
        url: "/kejuaraan-admin/evaluasi/monitoring-medali",
        columns,
        filter: [
          { dtype: "q", name: "q", colsize: 3 },
          { dtype: "dropdown", name: "id_cabor", label: "Cabor", colsize: 3, options: caborOptions, valueId: "id_cabor", labelId: "nama", placeholder: "-Semua Cabor-" },
          { dtype: "dropdown", name: "id_nomor_kategori", label: "Kategori", colsize: 3, options: kategoriOptions, valueId: "id_nomor_kategori", labelId: "nama", placeholder: "-Semua Kategori-" },
          { dtype: "dropdown", name: "id_nomor_penentu_keberhasilan", label: "Penentu Keberhasilan", colsize: 3, options: penentuOptions, valueId: "id_nomor_penentu_keberhasilan", labelId: "nama", placeholder: "-Semua Penentu-" },
        ],
        sort_by: ["cabor_name", "nomor_pertandingan_name", "nomor_kategori_name", "penentu_keberhasilan_name", "target_name"],
      }}
      pdflist={{ title: "Monitoring Medali", columns }}
      xlslist={{ title: "Monitoring Medali", columns }}
      pdfconfig={{ orientation: "landscape" }}
    />
  );
}

export function KejuaraanAdminEvaluasiPeluangPage() {
  const numberCell = (val) => Number(val || 0);
  const coltype = {
    cabor_name: { label: "Cabang Olahraga", renderFunc: (val) => showEmpty(val), width: 230 },
    jml_nomor: { label: "Jml Nomor", renderFunc: numberCell, renderExportFunc: numberCell, width: 90, align: "center" },
    target_emas: { label: "Target Emas", renderFunc: numberCell, renderExportFunc: numberCell, width: 80, align: "center" },
    target_perak: { label: "Target Perak", renderFunc: numberCell, renderExportFunc: numberCell, width: 80, align: "center" },
    target_perunggu: { label: "Target Perunggu", renderFunc: numberCell, renderExportFunc: numberCell, width: 80, align: "center" },
    total_target: { label: "Total Target", renderFunc: numberCell, renderExportFunc: numberCell, width: 80, align: "center" },
    peluang_emas: { label: "Peluang Emas", renderFunc: numberCell, renderExportFunc: numberCell, width: 80, align: "center" },
    peluang_perak: { label: "Peluang Perak", renderFunc: numberCell, renderExportFunc: numberCell, width: 80, align: "center" },
    peluang_perunggu: { label: "Peluang Perunggu", renderFunc: numberCell, renderExportFunc: numberCell, width: 80, align: "center" },
    total_peluang: { label: "Total Peluang", renderFunc: numberCell, renderExportFunc: numberCell, width: 80, align: "center" },
  };
  const columns = ["no", "cabor_name", "jml_nomor", "target_emas", "target_perak", "target_perunggu", "total_target", "peluang_emas", "peluang_perak", "peluang_perunggu", "total_peluang"];

  return (
    <DataList
      title="Evaluasi Peluang"
      coltype={coltype}
      dlist={{
        url: "/kejuaraan-admin/evaluasi/peluang",
        columns,
        filter: [{ dtype: "q", name: "q", colsize: 3 }],
        sort_by: ["cabor_name", "jml_nomor", "target_emas", "target_perak", "target_perunggu", "total_target", "peluang_emas", "peluang_perak", "peluang_perunggu", "total_peluang"],
      }}
      pdflist={{ title: "Evaluasi Peluang", columns }}
      xlslist={{ title: "Evaluasi Peluang", columns }}
      pdfconfig={{ orientation: "landscape" }}
    />
  );
}

export function KejuaraanAdminEvaluasiCapaianEmasPage() {
  const numberCell = (val) => Number(val || 0);
  const coltype = {
    cabor_name: { label: "Cabang Olahraga", renderFunc: (val) => showEmpty(val), width: 260 },
    jml_nomor: { label: "Jml Nomor", renderFunc: numberCell, renderExportFunc: numberCell, width: 95, align: "center" },
    target_emas: { label: "Target Emas", renderFunc: numberCell, renderExportFunc: numberCell, width: 110, align: "center" },
    perolehan_emas: { label: "Perolehan Emas", renderFunc: numberCell, renderExportFunc: numberCell, width: 135, align: "center" },
    peluang_tambahan_emas: { label: "Peluang Tambahan Emas", renderFunc: numberCell, renderExportFunc: numberCell, width: 155, align: "center" },
    target_emas_terpenuhi: { label: "Target Emas Terpenuhi", renderFunc: numberCell, renderExportFunc: numberCell, width: 155, align: "center" },
    target_emas_tak_terpenuhi: { label: "Target Emas Tak Terpenuhi", renderFunc: numberCell, renderExportFunc: numberCell, width: 170, align: "center" },
  };
  const columns = ["no", "cabor_name", "jml_nomor", "target_emas", "perolehan_emas", "peluang_tambahan_emas", "target_emas_terpenuhi", "target_emas_tak_terpenuhi"];

  return (
    <DataList
      title="Evaluasi Capaian Emas"
      coltype={coltype}
      dlist={{
        url: "/kejuaraan-admin/evaluasi/capaian-emas",
        columns,
        filter: [{ dtype: "q", name: "q", colsize: 3 }],
        sort_by: ["cabor_name", "jml_nomor", "target_emas", "perolehan_emas", "peluang_tambahan_emas", "target_emas_terpenuhi", "target_emas_tak_terpenuhi"],
      }}
      pdflist={{ title: "Evaluasi Capaian Emas", columns }}
      xlslist={{ title: "Evaluasi Capaian Emas", columns }}
      pdfconfig={{ orientation: "landscape" }}
    />
  );
}
